'use strict';

function PaidOff() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this.init = function () {
    this._super();
    this.$node = $(this.node);
  };

  this.initAllReady = function () {
    this._super();
    this._setupLivechat();
  };

  this.initPage = function () {
    var _this = this;

    // TODO: add loan routing

    this.presenter.addComputedVariable('offerStatus', ['money.offers', 'money.offers._links.get_credit_detail', 'money.displayed_offer[0].expires_at'], function () {
      return _this._getOfferStatus();
    });

    this._pushAnalytics();
  };

  this._pushAnalytics = function () {
    this.analytics.forcePushEvent('virtual-page-view');
    this.analytics.forcePushEvent('loan-preapproval-data');
  };

  this._setupLivechat = function () {
    this._liveChat = this.$node.find('.js--live-chat');
    this._liveChatComponent = $("[data-mogo-ui='LiveChat']");

    if (this._liveChat.length && !this._liveChatComponent.length) {
      this._liveChat.mogo().create('LiveChat', { presenter: this.presenter });
    } else if (this._liveChatComponent.length && this._liveChatComponent.mogo().declaredClass) {
      this._liveChatComponent.mogo().minimizeChatOnPage();
      this._liveChat = this._liveChatComponent;
    }
  };

  this.destroy = function () {
    this.presenter.removeComputedVariable('offerStatus');
  };
}